export const safeJsonParse =(data)=>{
    try {
        return JSON.parse(data);
    } catch (error) {
        return data;
    }
}